import { TGeozoneMapDataForAPIs } from "../../types/map";
import { LegacyOrganizationEntityListingPayload } from "./Admin";

export type GeozoneType = "Circle" | "Polygon" | "Route";

export type LegacyGeozoneEntityListingPayload =
  LegacyOrganizationEntityListingPayload & {
    clientid?: number;
    geozoneid?: string;
    groupid?: string;
    isactive?: number;
    ordering?: string;
    sortid?: number;
  };

export type CreateOrganizationGeozonePayload = Partial<TLegacyGeozone> & {
  accountid: string;
  geozoneid: string;
  zonetype: TLegacyGeozoneType;
  sortid: number;
};

export type SingleOrganizationGeozonePayload = {
  account_id: string;
  geozone_id: string;
};

export type EditOrganizationGeozonePayload = Partial<TLegacyGeozone> & {
  accountid: string;
  geozoneid: string;
};

export type GeozoneVehicleGroup = string;
// {
//   id: number;
//   name: string;
//   organization: string;
// }

export enum LegacyGeozoneType {
  CIRCLE = 0, // POINT_RADIUS
  UNSUPPORTED = 1, // BOUNDED_RECT
  ROUTE = 2, // SWEPT_POINT_RADIUS, i.e. corridor / route
  POLYGON = 3, // POLYGON
}
export type TLegacyGeozoneType =
  | LegacyGeozoneType.CIRCLE
  | LegacyGeozoneType.POLYGON
  | LegacyGeozoneType.ROUTE;

export type TLegacyGeozone = {
  accountid: string;
  arrivalstatuscode: number | null;
  arrivalzone: number;
  autonotify: number;
  city: string;
  clientid: number;
  clientupload: number;
  contactphone: string;
  country: string;
  creationtime: number;
  departurestatuscode: number | null;
  departurezone: number;
  description: string;
  displayname: string;
  geozoneid: string;
  groupid: string;
  iconname: string;
  isactive: number;
  lastupdatetime: number;
  latitude1: number | null;
  latitude2: number | null;
  latitude3: number | null;
  latitude4: number | null;
  latitude5: number | null;
  latitude6: number | null;
  latitude7: number | null;
  latitude8: number | null;
  latitude9: number | null;
  latitude10: number | null;
  longitude1: number | null;
  longitude2: number | null;
  longitude3: number | null;
  longitude4: number | null;
  longitude5: number | null;
  longitude6: number | null;
  longitude7: number | null;
  longitude8: number | null;
  longitude9: number | null;
  longitude10: number | null;
  maxlatitude: number;
  maxlongitude: number;
  minlatitude: number;
  minlongitude: number;
  postalcode: string;
  priority: number;
  radius: number;
  reversegeocode: number;
  shapecolor: string;
  sortid: number;
  speedlimitkph: number;
  stateprovince: string;
  streetaddress: string;
  subdivision: string;
  vertices: string | null;
  zonepurposeid: string;
  zonetype: TLegacyGeozoneType;
  zoomregion: number;
};

export type OrganizationGeozone = {
  id: number;
  created_at: string;
  updated_at: string;
  zone_id: string;
  zone_type: GeozoneType;
  // city: string | null;
  properties: TGeozoneMapDataForAPIs;
  description: string | null;
  geocode: string | null;
  radius: string | null;
  lat_lng: string | null; // comma separated lat,lng
  overlap_priority: number;
  reverse_geocode: boolean;
  arrival_geozone: boolean;
  departure_zone: boolean;
  zone_color: string;
  speed_limit: number | null;
  is_active: boolean;
  organization: string;
  groups: GeozoneVehicleGroup[];
};
